import { render } from "./AppSubmenu.vue?vue&type=template&id=64ad4bb3&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-64ad4bb3"

export default script